import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import AuthLayout from "../components/AuthLayout";
import FormField from "../components/FormField";
import Button from "../components/Button";
import Alert from "../components/Alert";
import { cerberus } from "../api/cerberus";
import { useSubmit } from "../lib/useSubmit";
import { parseReturnTo } from "../lib/returnTo";

export default function Signup(): JSX.Element {
  const [search] = useSearchParams();
  const returnTo = parseReturnTo(search.toString());

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [displayName, setDisplayName] = useState("");
  const [done, setDone] = useState(false);

  const { busy, error, onSubmit } = useSubmit(async () => {
    await cerberus.signup({
      email,
      password,
      display_name: displayName,
      return_to: returnTo ?? undefined,
    });
    setDone(true);
  }, "signup failed");

  if (done) {
    return (
      <AuthLayout
        title="Verifique seu email"
        subtitle="Enviamos um link de confirmação. Ele expira em 24h."
      >
        <Alert variant="success">
          Conta criada. Verifique a caixa de entrada de {email}.
        </Alert>
        <Link to={`/login${returnTo ? `?return_to=${encodeURIComponent(returnTo)}` : ""}`}>
          Voltar ao login
        </Link>
      </AuthLayout>
    );
  }

  return (
    <AuthLayout
      title="Criar conta"
      footer={
        <Link to={`/login${returnTo ? `?return_to=${encodeURIComponent(returnTo)}` : ""}`}>
          Ja tenho conta
        </Link>
      }
    >
      {error ? <Alert variant="error">{error}</Alert> : null}
      <form onSubmit={onSubmit} noValidate>
        <FormField
          label="Nome"
          name="display_name"
          autoComplete="name"
          required
          value={displayName}
          onChange={(e) => setDisplayName(e.target.value)}
        />
        <FormField
          label="Email"
          name="email"
          type="email"
          autoComplete="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <FormField
          label="Senha"
          name="password"
          type="password"
          autoComplete="new-password"
          minLength={8}
          required
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <Button type="submit" disabled={busy}>
          {busy ? "Criando..." : "Criar conta"}
        </Button>
      </form>
    </AuthLayout>
  );
}
